import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {MAX_MATCH_PAIR_COMMENT_LENGTH, MAX_MATCH_PAIR_LENGTH, MIN_ANSWER_LENGTH} from './constant';
import {questionBaseValidator} from './questionBase';

export const pairElementValidator = z.object({
    text: z.string().min(1, `text;min;${MIN_ANSWER_LENGTH}`).max(MAX_MATCH_PAIR_LENGTH, `text;max;${MAX_MATCH_PAIR_LENGTH}`),
    comment: z.string().max(MAX_MATCH_PAIR_COMMENT_LENGTH, `comment;max;${MAX_MATCH_PAIR_COMMENT_LENGTH}`).optional(),
});

export const matchPairQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.MATCH_PAIR_QUESTION),
    leftElement: z.array(pairElementValidator).min(2, 'leftElement;min;2'),
    rightElement: z.array(pairElementValidator).min(2, 'rightElement;min;2'),
});
